import React from 'react';
import SplashScreen from './Components/SplashScreen/SplashScreen';
import './style.css';

const App = () => {
  return (
    <div className="app">
      <SplashScreen />
    </div>
  );
}

export default App;
